import React from "react";
import ReactDOM from "react-dom";
//import './index.css';
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const resizeObserverErrorRegex =
  /ResizeObserver loop/i;

const getMessage = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (typeof value.message === "string") return value.message;
  if (typeof value.reason === "string") return value.reason;
  return "";
};

const extractErrorText = (...values) => {
  for (let i = 0; i < values.length; i += 1) {
    const message = getMessage(values[i]);
    if (message) return message;
  }
  return "";
};

const isResizeObserverError = (...values) => {
  const message = extractErrorText(...values);
  return resizeObserverErrorRegex.test((message || "").trim());
};

if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

const suppressResizeObserverError = (event) => {
  if (!isResizeObserverError(event?.message, event?.reason, event?.error))
    return false;
  event?.preventDefault?.();
  event?.stopImmediatePropagation?.();
  event?.stopPropagation?.();
  return true;
};

window.addEventListener("error", suppressResizeObserverError, true);
window.addEventListener("unhandledrejection", suppressResizeObserverError, true);

const originalWindowOnError = window.onerror;
window.onerror = function (message, source, lineno, colno, error) {
  if (isResizeObserverError(message, error)) return true;
  if (typeof originalWindowOnError === "function") {
    return originalWindowOnError.call(
      window,
      message,
      source,
      lineno,
      colno,
      error
    );
  }
  return false;
};

const originalConsoleError = console.error;
console.error = (...args) => {
  if (isResizeObserverError(args?.[0], args?.[1], args?.[2])) return;
  originalConsoleError(...args);
};

const styleLink = document.createElement("link");
styleLink.rel = "stylesheet";
styleLink.href =
  "https://cdn.jsdelivr.net/npm/semantic-ui/dist/semantic.min.css";
document.head.appendChild(styleLink);

ReactDOM.render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
